import script from "./TrialCreateView.vue?vue&type=script&setup=true&lang=js"
export * from "./TrialCreateView.vue?vue&type=script&setup=true&lang=js"

import "./TrialCreateView.vue?vue&type=style&index=0&id=5ff816d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ff816d2"]])

export default __exports__